module.exports = __webpack_public_path__ + "img/lg.ae5438dc.png";